// Free play: the server behind play.valkenhall.com runs with every
// progression mechanic off (FREE_PLAY=1 on that service only) and says so
// in the profile it returns at login. No rewards, currencies, store,
// trading, classes, quests or achievements; every card and cosmetic is
// available to everyone. The beta server behind qa.valkenhall.com never
// sets it, so QA keeps the full progression game from the same build.
//
// The server is the only source: a baked build flag could disagree with
// the server the client is talking to. Read isFreePlay() at render time,
// never at module scope; it is false until the first profile arrives.

let freePlay = false;

export function isFreePlay() {
  return freePlay;
}

// Called from app.jsx profileFromServer with every profile the server
// sends (login, GET /profile/me, profile:update pushes).
export function setFreePlay(value) {
  freePlay = !!value;
}
